import React from "react";
import { Helmet } from "react-helmet";

interface MetaTagsProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  imageUrl?: string;
}

export const MetaTags: React.FC<MetaTagsProps> = ({
  title,
  description,
  keywords,
  canonicalUrl,
  imageUrl,
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
    {imageUrl && <meta property="og:image" content={imageUrl} />}
    <meta property="og:type" content="website" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    {imageUrl && <meta name="twitter:image" content={imageUrl} />}
  </Helmet>
);
